import React, { Suspense } from "react";
import { Outlet } from "react-router-dom";
import LinearLoader from "../../AppComponents/Loader/LinearLoader";
import useDocumentTitle from "../../Hooks/useDocumentTitle";
import useFavicon from "../../Hooks/useFavicon";
interface Props {
  layoutWithDiv?: boolean;
  documentTitle?: string;

}

const BlankLayout: React.FC<Props> = ({
  layoutWithDiv = false,
  documentTitle = "",
  
}) => {
  useDocumentTitle(documentTitle);
  useFavicon();

  if (layoutWithDiv) {
    return (
      <Suspense fallback={<LinearLoader $position="relative" />}>
        <div style={{ width: "100%" }}>
          <Outlet />
        </div>
      </Suspense>
    );
  }

  return (
    <Suspense fallback={<LinearLoader $position="relative" />}>
      <Outlet />
    </Suspense>
  );
};

export default BlankLayout;
